import AlternativesList from './AlternativesList'

export default AlternativesList
